import { isMemberRecordReadOnly } from '../../features/publicMember/types';

export type ScheduleMemberPickerOption = {
    value: string;
    label: string;
    status?: string;
    memberships: any[];
    profileColorType?: string;
    profileImageUrl?: string;
    profileName?: string;
    appAccountStatus?: 'linked' | 'withdrawn' | 'unlinked';
    appWithdrawnAt?: string | null;
    appWithdrawalAuthStatus?: 'pending' | 'revoked' | null;
    isReadOnly?: boolean;
    onboardingPending?: boolean;
    onboardingStale?: boolean;
};

export const isScheduleMemberPickerReadOnly = (member: any): boolean =>
    isMemberRecordReadOnly(member);

/** 신규 수업의 쓰기 대상만 선택지로 변환한다. */
export const buildWritableScheduleMemberOptions = (
    members: any[] = []
): ScheduleMemberPickerOption[] =>
    (Array.isArray(members) ? members : [])
        .filter((member) => !isScheduleMemberPickerReadOnly(member))
        .map((member) => ({
            value: member?.memberId,
            label: member?.alias,
            status: member?.membershipStatus,
            memberships: member?.memberships || [],
            profileColorType: member?.profileColorType,
            profileImageUrl: member?.profileImageUrl,
            profileName: member?.profileName,
            appAccountStatus: member?.appAccountStatus,
            appWithdrawnAt: member?.appWithdrawnAt || null,
            appWithdrawalAuthStatus: member?.appWithdrawalAuthStatus || null,
            isReadOnly: member?.isReadOnly === true,
            onboardingPending: member?.onboardingPending,
            onboardingStale: member?.onboardingStale,
        }));

/** 목록 갱신 중 탈퇴한 회원은 기존 선택에서도 제거하고 최신 수강권으로 교체한다. */
export const refreshSelectedScheduleMembers = (
    selectedMembers: any[] = [],
    options: ScheduleMemberPickerOption[] = []
) =>
    (Array.isArray(selectedMembers) ? selectedMembers : []).flatMap((selected) => {
        const refreshed = options.find((option) => option.value === selected?.value);
        return refreshed ? [{ ...selected, ...refreshed }] : [];
    });
